import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Dayjs } from "dayjs";
import { styled } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import IconButton from "@mui/material/IconButton";

interface DateTimePickerProps {
  label: string;
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
}

const StyledButton = styled(IconButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

export default function CustomDateTimePicker({
  label,
  value,
  onChange,
}: DateTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        value={value}
        onChange={onChange}
        slots={{
          openPickerIcon: CalendarMonthIcon,
          openPickerButton: StyledButton,
        }}
        slotProps={{
          openPickerIcon: { fontSize: "medium" },
          openPickerButton: { color: "primary" },
        }}
        sx={{
          "& .MuiInputBase-root": {
            backgroundColor: "#f5f7f9",
            borderRadius: "8px",
          },
          "& .css-1g8t5bg-MuiPaper-root-MuiPickersPopper-paper": {
            background: "white",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "none",
          },
          "& .MuiInputLabel-root": {
            color: "#4CAF50",
          },
          "& .MuiDateCalendar-root": {
            backgroundColor: "#fff",
          },
          width: "100%",
          color: "black",
          backgroundColor: "#fff",
        }}
      />
    </LocalizationProvider>
  );
}
